// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2CS1s","consentsList":"PatientConsents_consentsList__Jf9I1","consentsListEmpty":"PatientConsents_consentsListEmpty__2oCHc"};